"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const mobx_1 = require("mobx");
require("./index.scss");
const InputText_1 = __importDefault(require("@Components/Fields/InputText"));
const Button_1 = require("@Components/Buttons/Button");
const DatePicker_1 = __importDefault(require("@Components/Fields/DatePicker"));
const removers_1 = require("@App/helpers/work-entities/removers");
const contexts_1 = require("@App/contexts");
class EditRecording extends react_1.default.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "title", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: this.props.editingRecording.title
        }); // max length 500
        Object.defineProperty(this, "titleError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "artistName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: this.props.editingRecording.artistName
        }); // max length 500
        Object.defineProperty(this, "artistNameError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "label", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "labelError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isrc", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: this.props.editingRecording.isrc
        }); // length 12
        Object.defineProperty(this, "isrcError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "duration", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: this.props.editingRecording.duration
        });
        Object.defineProperty(this, "releaseDate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: this.props.editingRecording.releaseDate
        });
        Object.defineProperty(this, "isDisabled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "getDate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (date) => {
                this.releaseDate = date;
                this.validator();
            }
        });
        Object.defineProperty(this, "getValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value, id) => {
                value = value.trim();
                switch (id) {
                    case 'title':
                        this.titleError = value.length > 200 ? 'Max length 200 symbol' : '';
                        this.title = value;
                        break;
                    case 'artistName':
                        this.artistNameError = value.length > 60 ? 'Max length 60 symbol' : '';
                        this.artistName = value;
                        break;
                    case 'isrc':
                        this.isrcError = value.length && value.length !== 12 ? 'ISRC length must be 12 characters' : '';
                        this.isrc = value;
                        break;
                    case 'label':
                        this.labelError = value.length > 60 ? 'Max length 60 symbol' : '';
                        this.label = value;
                        break;
                    case 'duration':
                        this.duration = value;
                        break;
                    default:
                        break;
                }
                this.validator();
            }
        });
        Object.defineProperty(this, "validator", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const isValid = this.title && !this.titleError && this.artistName && !this.artistNameError && !this.isrcError;
                this.isDisabled = !isValid;
            }
        });
        Object.defineProperty(this, "editRecording", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const workDraftFromLocal = this.context.workStore.workDraftLocal;
                const editingRecordingsId = this.props.editingRecording.localId;
                if (!workDraftFromLocal || !editingRecordingsId) {
                    return;
                }
                const recordings = workDraftFromLocal.recordings;
                const indexOfRecording = recordings
                    .map((recording) => recording.localId)
                    .indexOf(editingRecordingsId);
                const updatedRecording = {
                    localId: editingRecordingsId,
                    title: this.title, // REQUIRED FIELD
                    artistName: this.artistName, // REQUIRED FIELD
                    isrc: this.isrc ? this.isrc : null,
                    duration: this.duration ? this.duration : null,
                    label: this.label ? this.label : null,
                    releaseDate: this.releaseDate ? this.releaseDate : null,
                };
                const updatedRecordingsArray = (0, removers_1.setItemToArrayByIndex)(recordings, +indexOfRecording, updatedRecording);
                const updatedWorkDraft = Object.assign(Object.assign({}, workDraftFromLocal), { recordings: updatedRecordingsArray });
                this.context.workStore.setWorkDraftToLocal(updatedWorkDraft);
                this.props.closePopupFunc();
            }
        });
        (0, mobx_1.makeObservable)(this, {
            title: mobx_1.observable,
            titleError: mobx_1.observable,
            artistName: mobx_1.observable,
            artistNameError: mobx_1.observable,
            label: mobx_1.observable,
            labelError: mobx_1.observable,
            isrc: mobx_1.observable,
            isrcError: mobx_1.observable,
            duration: mobx_1.observable,
            releaseDate: mobx_1.observable,
            isDisabled: mobx_1.observable,
            getDate: mobx_1.action,
            getValue: mobx_1.action,
            validator: mobx_1.action,
            editRecording: mobx_1.action,
        });
    }
    render() {
        return (react_1.default.createElement("div", { className: "recording-sub-form-component" },
            react_1.default.createElement("h2", null, "Edit recording"),
            react_1.default.createElement("div", { className: "inputs-field" },
                react_1.default.createElement(InputText_1.default, { mainColor: true, id: 'title', label: 'Recording Title', assistiveText: 'Required', errorMessage: this.titleError, value: this.title, onChange: this.getValue }),
                react_1.default.createElement(InputText_1.default, { mainColor: true, id: 'artistName', label: 'Recording Artist Name', assistiveText: 'Required', errorMessage: this.artistNameError, value: this.artistName, onChange: this.getValue }),
                react_1.default.createElement(InputText_1.default, { mainColor: true, id: 'isrc', label: 'ISRC', errorMessage: this.isrcError, value: this.isrc, onChange: this.getValue }),
                react_1.default.createElement(InputText_1.default, { mainColor: true, id: 'label', label: 'Label', errorMessage: this.labelError, onChange: this.getValue }),
                react_1.default.createElement(InputText_1.default, { mainColor: true, id: 'duration', label: 'Duration', value: `${this.duration}`, onChange: this.getValue }),
                react_1.default.createElement(DatePicker_1.default, { id: 'releaseDate', label: 'Release Date', onChange: this.getDate })),
            react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', onClick: this.editRecording, disabled: this.isDisabled }, "Edit recording")));
    }
}
exports.default = (0, mobx_react_1.observer)(EditRecording);
EditRecording.contextType = contexts_1.StoresContext;
